import { render } from "./player.vue?vue&type=template&id=2e5f066e&scoped=true"
import script from "./player.vue?vue&type=script&lang=js"
export * from "./player.vue?vue&type=script&lang=js"

import "./player.vue?vue&type=style&index=0&id=2e5f066e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5f066e"]])

export default __exports__